import React, { Component } from 'react';
import fire from '../fire';
import RankingListItem from './RankingListItem';
import './RankingListPersonalRank.css';

class RankingListPersonalRank extends Component {
    constructor(props) {
        super(props);
        this.state = {ranking: [], userRank: 0, userAfter: [], userBefore: [], userSelf: []};
        this.ranking = [];
    }

    componentWillMount(){
        let userRankingRef = fire.database().ref('v1/betting/ranking/' + this.props.user.uid);
        userRankingRef.on('value', snapshot => {
            this.setState({userBefore: []});
            this.setState({userAfter: []});

            let userSelf = {key: snapshot.key, value: snapshot.val()};
            this.setState({userSelf: userSelf});

            let position = snapshot.val().position;
            this.setState({userRank: position});

            let userRankingBeforeRef = fire.database().ref('v1/betting/ranking').orderByChild('position').equalTo(position - 1).limitToFirst(1);
            userRankingBeforeRef.once('value', snapshot => {
                snapshot.forEach(function (element) {
                    let userBefore = {key: element.key, value: element.val()};
                    this.setState({userBefore: userBefore});
                }.bind(this));
            });
            let userRankingAfterRef = fire.database().ref('v1/betting/ranking').orderByChild('position').equalTo(position + 1).limitToFirst(1);
            userRankingAfterRef.once('value', snapshot => {
                snapshot.forEach(function (element) {
                    let userAfter = {key: element.key, value: element.val()};
                    this.setState({userAfter: userAfter});
                }.bind(this));
            });
        });
    }

    render() {
        if (this.state.userRank === 10 && this.state.userAfter.value) {
            return (<RankingListItem rank={this.state.userAfter.value} key={'personal-' + this.state.userAfter.key} rankUser={this.state.userAfter.key} user={this.props.user} />);
        }
        if (this.state.userRank === 11) {
            if (this.state.userAfter.value) {
                return (
                    <div>
                        <RankingListItem rank={this.state.userSelf.value} key={'personal-' + this.state.userSelf.key} rankUser={this.state.userSelf.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userAfter.value} key={'personal-' + this.state.userAfter.key} rankUser={this.state.userAfter.key} user={this.props.user} />
                    </div>
                );
            } else {
                return (<RankingListItem rank={this.state.userSelf.value} key={'personal-' + this.state.userSelf.key} rankUser={this.state.userSelf.key} user={this.props.user} />);
            }
        }
        if (this.state.userRank === 12 && this.state.userBefore.value) {
            if (this.state.userAfter.value) {
                return (
                    <div>
                        <RankingListItem rank={this.state.userBefore.value} key={'personal-' + this.state.userBefore.key} rankUser={this.state.userBefore.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userSelf.value} key={'personal-' + this.state.userSelf.key} rankUser={this.state.userSelf.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userAfter.value} key={'personal-' + this.state.userAfter.key} rankUser={this.state.userAfter.key} user={this.props.user} />
                    </div>
                );
            } else {
                return (
                    <div>
                        <RankingListItem rank={this.state.userBefore.value} key={'personal-' + this.state.userBefore.key} rankUser={this.state.userBefore.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userSelf.value} key={'personal-' + this.state.userSelf.key} rankUser={this.state.userSelf.key} user={this.props.user} />
                    </div>
                );
            }

        }
        if (this.state.userRank > 12 && this.state.userBefore.value) {
            if (this.state.userAfter.value) {
                return (
                    <div>
                        <div className="ranking-list-item row placeholder"><div className="col-12">...</div></div>
                        <RankingListItem rank={this.state.userBefore.value} key={'personal-' + this.state.userBefore.key} rankUser={this.state.userBefore.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userSelf.value} key={'personal-' + this.state.userSelf.key} rankUser={this.state.userSelf.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userAfter.value} key={'personal-' + this.state.userAfter.key} rankUser={this.state.userAfter.key} user={this.props.user} />
                    </div>
                );
            } else {
                return (
                    <div>
                        <div className="ranking-list-item row placeholder"><div className="col-12">...</div></div>
                        <RankingListItem rank={this.state.userBefore.value} key={'personal-' + this.state.userBefore.key} rankUser={this.state.userBefore.key} user={this.props.user} />
                        <RankingListItem rank={this.state.userSelf.value} key={'personal-' + this.state.userSelf.key} rankUser={this.state.userSelf.key} user={this.props.user} />
                    </div>
                );
            }
        }
        return (<div/>);
    }
}

export default RankingListPersonalRank;


// WEBPACK FOOTER //
// ./src/Ranking/RankingListPersonalRank.js